/* eslint-disable @typescript-eslint/camelcase */
import { all, put, takeLatest } from 'redux-saga/effects';
import {
  getAuditLogsRequest,
  getAuditLogsFulfilled,
  getAuditLogsRejected,
  getContextAuditLogsFulfilled,
  getContextAuditLogsRejected,
  getContextAuditLogsRequest,
} from './actions';
import endpoints, { api } from './endpoints';

function* getAuditLogsRequestSaga({ payload }) {
  try {
    const { data } = yield api.get({
      url: endpoints.getAuditLogs(payload),
    });

    return yield put(getAuditLogsFulfilled(data));
  } catch (e) {
    return yield put(getAuditLogsRejected());
  }
}

function* getContextAuditLogsRequestSaga({ payload }) {
  const { query, resource, resource_uuid, action } = payload;
  try {
    const { data } = yield api.get({
      url: endpoints.getContextAuditLogs(
        query,
        resource,
        resource_uuid,
        action
      ),
    });

    return yield put(getContextAuditLogsFulfilled(data));
  } catch (e) {
    return yield put(getContextAuditLogsRejected());
  }
}

export default all([
  takeLatest(getAuditLogsRequest, getAuditLogsRequestSaga),
  takeLatest(getContextAuditLogsRequest, getContextAuditLogsRequestSaga),
]);
